// extracted by mini-css-extract-plugin
export default {"downloadLink":"styles_downloadLink__DkfTd"};